import {
  CHANGE_PROPS_MODAL_ACTION,
  CLOSE_MODAL_ACTION,
  OPEN_MODAL_ACTION,
} from './ModalActions';

const INITIAL_STATE = {
  modals: [],
};

const getStateToOpenTooltip = (state, tooltip) => {
  let newState = { ...state };
  const modalIndex = state.modals
    .map(function (tooltipItem) {
      return tooltipItem.key;
    })
    .indexOf(tooltip.key);
  if (modalIndex > -1) {
    newState.modals[modalIndex] = tooltip;
  } else {
    newState.modals.push(tooltip);
  }
  return newState;
};

const getStateChangedProps = (state, key, componentProps) => {
  let newState = { ...state };
  const modalIndex = state.modals
    .map(function (tooltipItem) {
      return tooltipItem.key;
    })
    .indexOf(key);
  if (modalIndex > -1) {
    newState.modals[modalIndex] = {
      ...newState.modals[modalIndex],
      componentProps: {
        ...newState.modals[modalIndex].componentProps,
        ...componentProps,
      },
    };
  }
  return newState;
};

const getStateToCloseTooltip = (state, key) => {
  let newState = { ...state };
  const tooltipIndex = state.modals
    .map(function (tooltipItem) {
      return tooltipItem.key;
    })
    .indexOf(key);
  if (tooltipIndex > -1) {
    newState.modals[tooltipIndex] = {
      ...newState.modals[tooltipIndex],
      opened: false,
    };
  }
  return newState;
};

export default function ModalReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OPEN_MODAL_ACTION:
      return getStateToOpenTooltip(state, action.payload);
    case CHANGE_PROPS_MODAL_ACTION:
      return getStateChangedProps(
        state,
        action.payload.key,
        action.payload.componentProps
      );
    case CLOSE_MODAL_ACTION:
      return getStateToCloseTooltip(state, action.payload);
    default:
      return state;
  }
}
